import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px -10% 0px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal for headings
export const MaskLines = ({ lines, className = "", start = false, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} style={{ display: "block", overflow: "hidden" }}>
        <motion.span
          style={{ display: "block" }}
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : {}}
          transition={{ duration: 1.05, delay: 0.35 + i * stagger, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Editorial marquee ribbon
export const Marquee = ({ items, className = "" }) => {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden no-scrollbar ${className}`}>
      <div className="marquee-track">
        {doubled.map((it, i) => (
          <span key={i} className="font-display italic inline-flex items-center">
            <span className="px-8">{it}</span>
            <span className="opacity-50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
